import { render, staticRenderFns } from "./World.vue?vue&type=template&id=adab4934&scoped=true&"
var script = {}
import style0 from "./World.vue?vue&type=style&index=0&id=adab4934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adab4934",
  null
  
)

export default component.exports